export class AngularMenuItem {
    action: string;
    funzione: string;
    icona: string;
    param: any;
    label_breadcrumb : string;
    id_funzione:number;
}


// WEBPACK FOOTER //
// ./src/angular_library/models/angular-menu-item.ts